module.exports = __webpack_public_path__ + "static/media/ahri.e9c9efd8.png";